import React from 'react';
import ReactDOM from 'react-dom/client'; // Import createRoot from react-dom/client

import * as serviceWorker from './serviceWorker';
import App from './App';

// Create a root.
const root = ReactDOM.createRoot(document.getElementById('root'));

// Initial render
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Unregister the service worker if needed
serviceWorker.unregister();
